import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { placeNames } from 'src/helpers/globalVariables'
import { formatAddress } from 'src/helpers/ordersUtiles'
import { resetAllAdminFiltersAndPagination } from 'src/views/RequestsManagement/components/NewRequestsTable/consts/table-stores.data'
import { adminServiceTabStore } from 'src/views/Service/components/AdminTables/stores/AdminServiceTablesStore'
import newRequestIcon from '../../../assets/images/orderStatuses/new.svg'
import uploadByAdminIcon from '../../../assets/images/orderStatuses/uploadByAdmin.svg'
import { useConfirmAddress } from '../../../hooks/useConfirmAddress'
import { useInvalidateQueries } from '../../../hooks/useInvalidateQueries'
import {
  isAdmin,
  isAdminType2,
  isAdministration,
  isDealerOperator,
  isOperator,
} from '../../../services/AccountService'
import {
  addOrder,
  addOrderByAdmin,
  addOrderByDealer,
} from '../../../services/ApiService'
import { notifySuccess } from '../../../services/ToastifyService/ToastifyService'
import { gState } from '../../../utils/controllers/GlobalStateController'
import {
  closeModalFn,
  openModalFn,
} from '../../../utils/controllers/ModalController'
import { getComp } from '../../../utils/utils/DI'
import { REQUEST_CLARIFICATION_KEYS } from '../../../views/RequestsManagement/RequestsSecondOperator/Table/hooks/useRequestsData'
import FormInput from '../../customElements/FormInput'
import MultipleSelect from '../../customElements/MultipleSelect/MultipleSelect'
import FinancialSourceAccordio from '../../customElements/RequestDataAccordions/FinancialSourceAccordio'
import CustomAccordion from '../../customElements/RequestDataAccordions/utils/CustomAccordion'
import AddRequestFormStore from '../stores/AddRequestFormStore'
import AdminAddFormStore from '../stores/AdminAddFormStore'
import BaseInputsFormStore from '../stores/BaseInputsFormStore'
import AddAdminForm from './AddAdminForm'

function AddRequestForm({ filterStore, ordersStore }) {
  const intl = gState['intl']
  const invalidate = useInvalidateQueries()
  const [value, setValue] = useState(null)
  const [disabled, setDisabled] = useState(false)
  const { shownSenders, defaultSenders } = getComp('SendersStore')
  const territoryStore = getComp('TerritoryStore')
  const categoriesStore = getComp('CategoriesStore')
  const { reasons } = getComp('InstallationReasonStore')
  const [formStore] = useState(() => new AddRequestFormStore())
  const [adminAddFormStore] = useState(() => new AdminAddFormStore())
  const [baseInputsFormStore] = useState(() => new BaseInputsFormStore())
  const { canCreateOrder, canCreateLoadedByOperatorOrder } =
    getComp('UserInfoStore')
  const { mutateAsync, isPending } = useConfirmAddress()

  // задает значение даты в поле
  // меняет стили обязательных полей
  useEffect(() => {
    formStore.showErrors = !baseInputsFormStore.data['reasonId'] ? false : true
    formStore.data['created'] = !baseInputsFormStore.data['reasonId']
      ? ''
      : moment().format('DD-MM-YYYY,HH:mm')

    adminAddFormStore.data['created'] = !baseInputsFormStore.data['reasonId']
      ? ''
      : moment().format('DD-MM-YYYY,HH:mm')

    adminAddFormStore.showErrors = !baseInputsFormStore.data['reasonId']
      ? false
      : true
  }, [baseInputsFormStore.data['reasonId']])

  useEffect(() => {
    baseInputsFormStore.showErrors = baseInputsFormStore.data['requisition']
      ? true
      : false
  }, [baseInputsFormStore.data['requisition']])

  const getItems = () => {
    const items = []

    canCreateOrder &&
      items.push({
        key: 'Новая заявка',
        value: '1',
        icon: <img src={newRequestIcon} />,
      })

    canCreateLoadedByOperatorOrder &&
      items.push({
        key: 'Добавлена администратором',
        value: '2',
        icon: <img src={uploadByAdminIcon} />,
      })

    return items
  }

  let firstInput = [
    {
      propName: 'reasonId',
      validName: 'reasonId',
      label: intl.formatMessage({ id: 'Причина обращения' }),
      items: reasons,
      type: 'select',
    },
    {
      propName: 'requisition',
      validName: 'requisition',
      label: intl.formatMessage({ id: 'Заявка' }),
      items: getItems(),
      type: 'select',
    },
  ]

  const [topInputs, setTopInputs] = useState(firstInput)

  useEffect(() => {
    if (!isAdminType2()) {
      firstInput = firstInput.filter((item) => item.propName !== 'requisition')
      setTopInputs(firstInput)
    }
  }, [])

  const editData = [
    {
      propName: 'surname',
      validName: 'surname',
      label: intl.formatMessage({ id: 'Фамилия' }),
      type: 'text',
      capitalizeFirstLetter: true,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'name',
      validName: 'name',
      label: intl.formatMessage({ id: 'Имя' }),
      type: 'text',
      capitalizeFirstLetter: true,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'patronymic',
      validName: 'patronymic',
      label: intl.formatMessage({ id: 'Отчество' }),
      type: 'text',
      capitalizeFirstLetter: true,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'phone',
      mask: '+7 (999)-999-99-99',
      label: intl.formatMessage({ id: 'Телефон' }),
      type: 'text',
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },

    {
      propName: 'territory',
      validName: 'territory',
      label: intl.formatMessage({ id: 'Регион' }),
      items: territoryStore.collection,
      type: 'select',
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'district',
      validName: 'district',
      label: intl.formatMessage({ id: 'Округ' }),
      autocompleteOptions: {
        territory: formStore.data['territory'],
        type: 'district',
      },
      readOnly: formStore.data.territory === '',
      disabled: formStore.data.territory === '',
      territorySelect: true,
      type: 'autocomplete',
    },
    {
      propName: 'locality',
      validName: 'locality',
      label: intl.formatMessage({ id: 'Населённый пункт' }),
      territorySelect: true,
      autocompleteOptions: {
        territory: formStore.data['territory'],
        district: formStore.data['district'],
        type: 'locality',
        fin: formStore.data['financialSourceId'],
      },
      readOnly: formStore.data.district === '',
      disabled: formStore.data.district === '',
      type: 'autocomplete',
    },
    {
      propName: 'addressType',
      validName: 'addressType',
      label: intl.formatMessage({ id: 'Топоним (улица / переулок и т.д.)' }),
      type: 'autocomplete',
      items: placeNames,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'address',
      validName: 'address',
      label: intl.formatMessage({
        id: 'Наименование топонима (улицы / переулка и т.д.)',
      }),
      type: 'text',
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'house',
      validName: 'house',
      label: intl.formatMessage({ id: 'Дом' }),
      type: 'text',
      onlyNumbers: true,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'building',
      validName: 'building',
      label: intl.formatMessage({ id: 'Корпус' }),
      type: 'text',
      onlyNumbersAndLetters: true,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'apartment',
      validName: 'apartment',
      label: intl.formatMessage({ id: 'Квартира' }),
      type: 'text',
      onlyNumbers: true,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    ...(isDealerOperator()
      ? []
      : [
          {
            propName: 'created',
            validName: 'created',
            label: intl.formatMessage({ id: 'Дата обращения' }),
            mask: '99-99-9999, 99:99',
            placeholder: !baseInputsFormStore.data['reasonId']
              ? null
              : 'DD-MM-YYYY, HH:mm',
            type: 'text',
            disabled: baseInputsFormStore.data['reasonId'] ? false : true,
          },
        ]),
    {
      propName: 'categories',
      validName: 'categories',
      label: intl.formatMessage({ id: 'Льготные категории' }),
      items: categoriesStore.collection.map((el) => {
        return { key: el.name, value: el.id }
      }),
      multiple: true,
      type: 'multiple',
      onClear: formStore.onClearMultiple,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'senderId',
      validName: 'senderId',
      label: intl.formatMessage({ id: 'Источник данных о заявке' }),
      items: shownSenders.map((el) => ({ key: el.name, value: el.id })),
      defaultValue:
        defaultSenders &&
        shownSenders.find((sender) => sender.id === defaultSenders)
          ? defaultSenders
          : '',
      type: 'select',
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
    {
      propName: 'additionalInfo',
      validName: 'additionalInfo',
      label: 'Дополнительная информация / краткое описание причины обращения',
      type: 'text',
      multiline: true,
      rows: 5,
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },

    {
      propName: 'hasDuplicates',
      validName: 'hasDuplicates',
      label: intl.formatMessage({ id: 'Повторное обращение' }),
      type: 'checkbox',
      visible:
        isAdmin() || isDealerOperator() || isOperator() || isAdministration(),
      disabled: baseInputsFormStore.data['reasonId'] ? false : true,
    },
  ]

  function normalizePhoneNumber(phoneNumber) {
    return phoneNumber.replace(/\D/g, '')
  }

  const handleAccept = async (priority) => {
    setDisabled(true)
    const data = {}

    priority === null
      ? (data['priority'] = null)
      : (data['priority'] = +priority)

    Object.keys(formStore.data).forEach((key) => {
      if (!!formStore.data[key] || key === 'reasonId') {
        data[key] =
          key === 'senderId'
            ? Number(formStore.data[key])
            : key === 'created'
              ? moment(formStore.data[key], 'DD-MM-YYYY,HH:mm')
                  .local(true)
                  .format()
              : key === 'categories'
                ? formStore.data['categories'].length
                  ? formStore.data['categories']
                  : [7]
                : key === 'reasonId'
                  ? +baseInputsFormStore.data['reasonId']
                  : key === 'hasDuplicates'
                    ? formStore.data['hasDuplicates']
                    : key === 'financialSourceId'
                      ? Number(formStore.data[key])
                      : key === 'phone'
                        ? normalizePhoneNumber(formStore.data[key])
                        : String(formStore.data[key])
      }
    })

    // если в селекте выбрано "Добавлена администратором" то вызывается специальный метод для добавления заявки
    if (+baseInputsFormStore.data['requisition'] === 2) {
      const params = {}
      Object.keys(adminAddFormStore.data).forEach((key) => {
        // проверка на резонАйди отдельно потому что этот параметр лежит в формСторе.
        // без этой проверки поле резонАйДи здесь будет пропущено и не попадет в парметры запроса
        if (!!adminAddFormStore.data[key] || key === 'reasonId') {
          params[key] =
            key === 'senderId'
              ? Number(adminAddFormStore.data[key])
              : key === 'created'
                ? moment(adminAddFormStore.data[key], 'DD-MM-YYYY,HH:mm')
                    .local(true)
                    .format()
                : key === 'installed'
                  ? moment(adminAddFormStore.data[key], 'DD-MM-YYYY,HH:mm')
                      .local(true)
                      .format()
                  : key === 'categories'
                    ? adminAddFormStore.data['categories'].length
                      ? adminAddFormStore.data['categories']
                      : [7]
                    : key === 'reasonId'
                      ? +baseInputsFormStore.data['reasonId']
                      : String(adminAddFormStore.data[key])
        }
      })
      fetch(`${window.location.origin}/version.json`)
        .then((res) => res.json())
        .then((version) => {
          addOrderByAdmin({ ...params, appVersion: version.version })
            .then((res) => {
              invalidate([REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE])
              if (res && Object.keys(res).length !== 1) {
                ordersStore.reLoad(
                  { page: 0, size: ordersStore.pageSize },
                  () =>
                    notifySuccess(intl.formatMessage({ id: 'Заявка создана' })),
                )
                closeModalFn['add-request']()
                filterStore.clear()
                setDisabled(false)
                invalidate(['requests-table'])
              }
            })
            .catch(() => {
              setDisabled(false)
            })
        })
      return
    }

    if (isDealerOperator()) {
      fetch(`${window.location.origin}/version.json`)
        .then((res) => res.json())
        .then(async (version) => {
          if (data.financialSourceId === 5) {
            const { hasExchanges } = await mutateAsync(data)

            if (hasExchanges) {
              setDisabled(false)
              openModalFn['transaction-confirmation']({
                text1: ` В системе на адрес ${formatAddress(data)} уже зарегистрирована заявка на установку с типом оплаты`,
                value1: `Обмен. `,
                text2: 'Подтвердить создание заявки?',
                action: () => {
                  setDisabled(true)
                  addOrderByDealer({ ...data, appVersion: version.version })
                    .then((res) => {
                      invalidate([REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE])
                      if (res && Object.keys(res).length !== 1) {
                        adminServiceTabStore.clearRequestsTab()
                        resetAllAdminFiltersAndPagination()
                        notifySuccess(
                          intl.formatMessage({ id: 'Заявка создана' }),
                        )
                        filterStore.clear()
                        setDisabled(false)
                        closeModalFn['add-request']()
                        closeModalFn['progress-backdrop']()
                        invalidate(['requests-table'])
                      }
                    })
                    .catch(() => {
                      setDisabled(false)
                      closeModalFn['progress-backdrop']()
                    })
                },
                processText: `Выполняется создание заявки`,
                dontBreakWords: true,
              })
            } else {
              addOrderByDealer({ ...data, appVersion: version.version })
                .then((res) => {
                  invalidate([REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE])
                  if (res && Object.keys(res).length !== 1) {
                    adminServiceTabStore.clearRequestsTab()
                    resetAllAdminFiltersAndPagination()
                    notifySuccess(intl.formatMessage({ id: 'Заявка создана' }))
                    filterStore.clear()
                    setDisabled(false)
                    closeModalFn['add-request']()
                    invalidate(['requests-table'])
                  }
                })
                .catch(() => {
                  setDisabled(false)
                })
            }
          } else {
            addOrderByDealer({ ...data, appVersion: version.version })
              .then((res) => {
                invalidate([REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE])
                if (res && Object.keys(res).length !== 1) {
                  adminServiceTabStore.clearRequestsTab()
                  resetAllAdminFiltersAndPagination()
                  notifySuccess(intl.formatMessage({ id: 'Заявка создана' }))
                  filterStore.clear()
                  setDisabled(false)
                  closeModalFn['add-request']()
                  invalidate(['requests-table'])
                }
              })
              .catch(() => {
                setDisabled(false)
              })
          }
        })
    } else {
      fetch(`${window.location.origin}/version.json`)
        .then((res) => res.json())
        .then((version) => {
          addOrder({ ...data, appVersion: version.version })
            .then((res) => {
              if (res && Object.keys(res).length !== 1) {
                if (isOperator()) {
                  notifySuccess(intl.formatMessage({ id: 'Заявка создана' }))
                  closeModalFn['add-request']()
                  invalidate([REQUEST_CLARIFICATION_KEYS.GET_REQUEST_TABLE])
                  filterStore.clear()
                  setDisabled(false)
                } else {
                  ordersStore.reLoad(
                    { page: 0, size: ordersStore.pageSize },
                    () =>
                      notifySuccess(
                        intl.formatMessage({ id: 'Заявка создана' }),
                      ),
                  )
                  invalidate(['requests-table'])

                  filterStore.clear()
                  setDisabled(false)
                  closeModalFn['add-request']()
                }
              }
            })
            .catch(() => {
              setDisabled(false)
            })
        })
    }
  }

  return (
    <Box
      mt={2}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box>
        {topInputs.map((el, i) => {
          const {
            propName,
            label,
            items,
            mask,
            defaultValue,
            autocompleteOptions,
            multiple,
            readOnly,
            disabled,
            type,
            visible,
            territorySelect,
            onClear,
            capitalizeFirstLetter,
            validName,
          } = el

          return (
            <Box
              key={i}
              sx={{ marginBottom: '12px', marginTop: '12px' }}
              px={2}
            >
              {multiple ? (
                <MultipleSelect
                  items={items}
                  value={baseInputsFormStore.data.categories}
                  onChange={baseInputsFormStore.onChangeMultiple}
                  label={label}
                  propName={propName}
                  readOnly={readOnly}
                  disabled={disabled}
                  onClear={onClear}
                  validName={validName}
                />
              ) : (
                <Box mt={i ? 1.5 : 0} key={i + ''}>
                  <FormInput
                    api={baseInputsFormStore}
                    type={type}
                    autocompleteOptions={autocompleteOptions}
                    items={!!items ? items : null}
                    propName={propName}
                    validName={validName}
                    fullWidth
                    defaultValue={defaultValue}
                    mask={mask}
                    label={label}
                    withoutErrorText
                    readOnly={readOnly}
                    disabled={disabled}
                    visible={visible}
                    territorySelect={territorySelect}
                    capitalizeFirstLetter={capitalizeFirstLetter}
                  />
                </Box>
              )}
            </Box>
          )
        })}

        {baseInputsFormStore.data['requisition'] &&
        +baseInputsFormStore.data['requisition'] === 2 ? (
          <AddAdminForm
            adminAddFormStore={adminAddFormStore}
            baseInputsFormStore={baseInputsFormStore}
          />
        ) : (baseInputsFormStore.data['requisition'] &&
            +baseInputsFormStore.data['requisition'] === 1) ||
          !isAdminType2() ? (
          <CustomAccordion
            summary={'Данные абонента'}
            defaultOpenState={true}
            preventHandleOpen={true}
          >
            {editData.map((el, i) => {
              const {
                propName,
                label,
                items,
                mask,
                defaultValue,
                autocompleteOptions,
                multiple,
                readOnly,
                disabled,
                type,
                visible,
                territorySelect,
                onClear,
                capitalizeFirstLetter,
                styles,
                multiline,
                validName,
                rows,
                onlyNumbers,
                onlyNumbersAndLetters,
              } = el

              return (
                <Box
                  mt={i ? 1.5 : 0}
                  key={i + 'createOrderInput'}
                  sx={{ marginTop: '12px' }}
                >
                  {multiple ? (
                    <MultipleSelect
                      items={items}
                      value={formStore.data.categories}
                      onChange={formStore.onChangeMultiple}
                      label={label}
                      propName={propName}
                      readOnly={readOnly}
                      disabled={disabled}
                      onClear={onClear}
                      validName={validName}
                    />
                  ) : (
                    <Box mt={i ? 1.5 : 0} key={i + ''}>
                      <FormInput
                        api={formStore}
                        type={type}
                        autocompleteOptions={autocompleteOptions}
                        items={!!items ? items : null}
                        propName={propName}
                        validName={validName}
                        fullWidth
                        defaultValue={defaultValue}
                        mask={mask}
                        label={label}
                        withoutErrorText
                        readOnly={readOnly}
                        disabled={disabled}
                        visible={visible}
                        territorySelect={territorySelect}
                        capitalizeFirstLetter={capitalizeFirstLetter}
                        styles={styles}
                        multiline={multiline}
                        onlyNumbers={onlyNumbers}
                        onlyNumbersAndLetters={onlyNumbersAndLetters}
                      />
                    </Box>
                  )}
                </Box>
              )
            })}
          </CustomAccordion>
        ) : null}
        {isAdminType2() ? (
          +baseInputsFormStore.data['requisition'] === 1 && (
            <FinancialSourceAccordio
              api={formStore}
              setFinancialSourceId={formStore.setFinancialSourceId}
              createRequest
              baseInputsFormStore={baseInputsFormStore}
              addReq
            />
          )
        ) : (
          <FinancialSourceAccordio
            api={formStore}
            setFinancialSourceId={formStore.setFinancialSourceId}
            createRequest
            baseInputsFormStore={baseInputsFormStore}
            addReq
          />
        )}
      </Box>
      <Box px={2}>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={() => handleAccept(value)}
          sx={{ margin: '24px 0 0 0' }}
          fullWidth
          disabled={
            isPending ||
            (+baseInputsFormStore.data['requisition'] === 2
              ? !adminAddFormStore.isValid || disabled
              : !formStore.isValid || disabled)
          }
        >
          <FormattedMessage id={'Создать заявку на установку'} />
        </Button>
        <Button
          color={'primary'}
          variant={'outlined'}
          onClick={() => closeModalFn['add-request']()}
          fullWidth
          sx={{ margin: '8px 0 24px 0' }}
        >
          <FormattedMessage id={'Отмена'} />
        </Button>
      </Box>
    </Box>
  )
}

export default observer(AddRequestForm)
